/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { CircularProgress, LinearProgress } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import ImageList from '@mui/material/ImageList';
import createStyles from '@mui/styles/createStyles';
import { withStyles } from '@mui/styles';
import * as React from 'react';
import { fetchUsersEndPoint, forceAssignServiceCaseEndPoint } from '../common/constants';
import { toGraphqlJsonBody } from '../common/graphqlJsonBody';
import { loadFromLocalStorage } from '../common/localStorage';

const styles = (theme: any) =>
    createStyles({
        root: {
            display: 'flex',
            flexWrap: 'nowrap' as const,
            justifyContent: 'flex-start',
            margin: '0 auto',
            overflowX: 'auto',
            overflowY: 'hidden',
            backgroundColor: (theme && theme.palette && theme.palette.background && theme.palette.background.paper) || '#ffffff',
            width: '420px'
        },
        gridList: {
            display: 'flex',
            flexWrap: 'nowrap',
            height: '90px',
            overflowX: 'auto',
            overflowY: 'hidden'
        },
        avatar: {
            backgroundColor: '#b2b2b2',
            color: '#ffffff',
            width: '40px',
            height: '40px'
        },
        firstName: {
            justifyContent: 'center',
            fontSize: '14px',
            fontFamily: '"Roboto Light", "Open Sans", Arial, sans-serif'
        },
        clickedAvatar: {
            backgroundColor: '#ffbe00',
            color: '#ffffff',
            width: '40px',
            height: '40px'
        },
        buttons: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            margin: '25px 10px 25px 25px'
        },
        cancel: {
            border: '1px solid #ffbe00'
        },
        save: {
            backgroundColor: '#ffbe00'
        },
        MuiGridList: {
            root: {
                overflowY: 'hidden',
                overflowX: 'auto'
            }
        },
        progressWrap: {
            textAlign: 'center' as const,
            width: '400px',
            height: '200px',
            marginTop: '30vh'
        },
        dimension: {
            minWidth: '400px',
            minHeight: '400px'
        }
    });

interface Props {
    classes: any,
    onClose: Function,
    selectedValue: string,
    open: boolean,
    users: any,
    servicecaselist: any,
    isUsersLoading: boolean
    //onalertClose: Function,
    //alertopen:boolean
}

interface User {
    firstname: string;
    lastname: string;
    userid: number;
}
class AlertDialog extends React.Component<{ alertopen: boolean, onalertclose: Function, onforceassign: Function, selecteduser: User, untrainedServiceCases: string }>{
    state = {

    };

    handleClose = () => {
        this.props.onalertclose();
    };

    forceAssign = () => {
        this.props.onforceassign(this.props.selecteduser);
    };

    render() {
        //const { onClose, selectedValue, classes, ...other } = this.props;
        return (
            <div>
                <Dialog
                    open={this.props.alertopen}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">{'Technician not Trained'}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <p style={{ color: 'red' }}>{this.props.untrainedServiceCases + '\n'}</p>
                            Our records indicate the technician selected is not trained on this product.
                            If this is not correct, please contact service_learn@trimble.com to update their training records.
                            Until the technician is trained on this model, they will not be able to file a warranty claim.
                            Do you want to continue to assign the Service Case?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            No
                        </Button>
                        <Button onClick={this.forceAssign} color="primary" autoFocus>
                            Yes
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}


class AssignToDialog extends React.Component<Props, { selectedUser: User | undefined, status: string, isalertopen: boolean, untrainedServiceCases: string, isLoading: boolean }> {
    state = {
        selectedUser: undefined,
        status: '',
        isalertopen: false,
        untrainedServiceCases: '',
        isLoading: false,
    };

    componentDidMount() {
        this.setState({
            selectedUser: undefined,
            status: '',
            isLoading: false,
        });
    }

    handleClose = () => {
        this.props.onClose(this.props.selectedValue);
        this.setState({
            selectedUser: undefined,
            status: ''
        });
    };

    handleAlertClose = () => {
        this.setState({ isalertopen: false });
    };

    handleAlertforceAssign = async (value: User) => {


        const servicecaselist = `${this.props.servicecaselist.join(';')}`;
        const requestBody = {
            userid: value.userid,
            servicecases: servicecaselist,
            forceassign: true
        };
        const token: string = loadFromLocalStorage('AuthToken');
        const encodedToken = 'Bearer ' + token;
        const headerDict: any = {
            'Authorization': encodedToken,
            'Content-Type': 'application/json'
        };

        try {
            if (navigator.onLine) {
                const response = await fetch(forceAssignServiceCaseEndPoint, {
                    headers: new Headers(headerDict),
                    body: JSON.stringify(requestBody),
                    method: 'POST'
                });


                if (response.status === 200) {
                    this.setState({ status: 'Success' });
                    window.location.reload();
                }
                else {
                    this.setState({ status: 'Error' });
                    this.setState({ isalertopen: false });
                }
                return response;
            }
        }
        catch (e) {
            console.log(e);
        }
    };

    handleListItemClick = (value: any) => {
        this.props.onClose(value);
    };
    handleAvatarClick = (value: User) => {
        this.setState({ selectedUser: value });
    };
    handleSave = (value: User) => {
        if (this.state.selectedUser !== undefined && navigator.onLine) {
            this.setState({ isLoading: true });
            const servicecaselist = `${this.props.servicecaselist.join(';')}`;
            const token: string = loadFromLocalStorage('AuthToken');
            const encodedToken = 'Bearer ' + token;
            const headerDict: any = {
                'Authorization': encodedToken,
                'Content-Type': 'application/json'
            };
            const requestBody = {
                userid: value.userid,
                servicecases: servicecaselist,
                forceassign: false
            };

            try {
                if (navigator.onLine) {
                    fetch(forceAssignServiceCaseEndPoint, {
                        headers: new Headers(headerDict),
                        body: JSON.stringify(requestBody),
                        method: 'POST'
                    })
                        .then(async (response: any) => {
                            const data = await response.json();

                            switch (response.status) {
                                case 200:
                                    this.setState({ status: 'Success' });

                                    window.location.reload();
                                    break;
                                case 400:
                                    this.setState({ status: data.message });

                                    break;
                                case 422:
                                    this.setState({ isalertopen: true, untrainedServiceCases: data.message });
                                    break;
                                default:
                                    this.setState({ status: 'Error' });
                            }
                            this.setState({ isLoading: false });
                            return data;

                        });
                }
            }
            catch (e) {
                this.setState({ isLoading: false });
            }


        }
    };
    render() {
        const { classes } = this.props;
        const selectedUser: any = this.state.selectedUser === undefined ? { userid: 0, firstname: '', lastname: '' } as User : this.state.selectedUser;
        const loading = this.state.isLoading;
        return (
            <Dialog
                open={this.props.open}
                onClose={this.handleClose}
                aria-labelledby="simple-dialog-title"
                scroll="paper"
                className={classes.dimension}
                PaperProps={{ style: { width: 520, maxWidth: '90vw' } }}
            >
                {this.props.isUsersLoading ?
                    <div className={classes.progressWrap}>
                        <CircularProgress className={classes.progress} color="secondary" />
                    </div>
                    :
                    <div>
                        <DialogTitle id="simple-dialog-title">Users</DialogTitle>
                        <div style={{ padding: '25px' }}>
                            <div className={classes.root}>
                                <ImageList className={classes.gridList} cols={3}>
                                    {this.props.users.map((user: any) => {
                                        return (
                                            <div key={user.userid} style={{ width: 'auto', height: 'auto', textAlign: 'center' }} onClick={() => this.handleAvatarClick(user)}>
                                                <Avatar className={selectedUser.userid === user.userid ? classes.clickedAvatar : classes.avatar}  >
                                                    {user.firstname !== null && user.firstname[0]}
                                                </Avatar>
                                                <p className={classes.firstName}>{user.firstname != null && user.firstname.substring(0, 7)}</p>
                                            </div>
                                        );
                                    })}
                                </ImageList>
                            </div>
                        </div>
                        <div style={{ marginLeft: '25px' }}>
                            <p>Assign to</p>
                        </div>
                        <div style={{ marginLeft: '25px', color: '#ffbe00', fontWeight: 'bold', fontSize: '14px' }}>
                            {(selectedUser != null && selectedUser !== undefined) && (`${selectedUser.firstname  } ${  selectedUser.lastname}`)}
                        </div>

                        <div className={classes.buttons}>
                            <Button disabled={loading} className={classes.cancel} onClick={this.handleClose}>Cancel</Button>
                            <Button disabled={!!((selectedUser.userid === 0 || !navigator.onLine || loading))} className={classes.save}
                                onClick={() => { this.handleSave(selectedUser); }}>Save</Button>
                        </div>

                        {loading && <LinearProgress color="secondary" />}
                        <AlertDialog untrainedServiceCases={this.state.untrainedServiceCases} alertopen={this.state.isalertopen}
                            onalertclose={this.handleAlertClose} selecteduser={selectedUser} onforceassign={this.handleAlertforceAssign} />
                    </div>
                }
            </Dialog>
        );
    }
}

const AssignDialogWrapped = withStyles(styles)(AssignToDialog);

class AssignToDialogControl extends React.Component<
    { serviceCaseList: any; assigntodisabled: boolean },
    {}
> {
    state = {
        open: false,
        selectedValue: '',
        users: [],
        isUsersLoading: false
    };

    handleClickOpen = () => {
        this.loadUsers();
        this.setState({
            open: true
        });
    };

    handleClose = (value: any) => {
        this.setState({ selectedValue: value, open: false });
    };

    loadUsers = () => {
        this.setState({
            isUsersLoading: true
        });
        const query = 'query($orderby: String){ mycompanyusers(orderby: $orderby){ userid,firstname,lastname} }';
        const token: string = loadFromLocalStorage('AuthToken');
        const encodedToken = 'Bearer ' + token;
        const headerDict: any = {
            'Authorization': encodedToken,
            'Content-Type': 'application/json'
        };

        try {
            if (navigator.onLine) {
                fetch(fetchUsersEndPoint, {
                    headers: new Headers(headerDict),
                    body: toGraphqlJsonBody(query, { orderby: 'firstname:asc' }),
                    method: 'POST'
                }).then((response: any) => {
                    return response.json();
                }).then((responseData: any) => {
                    this.setState({ users: responseData.data.mycompanyusers }, () => {
                        this.setState({
                            open: true,
                            isUsersLoading: false
                        });
                    });
                });
            }
        }
        catch (e) {
        }
    };

    render() {
        const { users } = this.state;
        return (
            <div>
                <Button
                    disabled={this.props.assigntodisabled || !navigator.onLine}
                    variant="outlined"
                    style={
                        {
                            backgroundColor: '#ffffff',
                            marginRight: '5px'
                        } as React.CSSProperties
                    }
                    onClick={this.handleClickOpen.bind(this)}
                >
                    Assign To
                </Button>
                <AssignDialogWrapped
                    selectedValue={this.state.selectedValue}
                    open={this.state.open}
                    isUsersLoading={this.state.isUsersLoading}
                    onClose={this.handleClose}
                    users={users}
                    servicecaselist={this.props.serviceCaseList}
                />
            </div>
        );
    }
}

export default AssignToDialogControl;
